module.exports = __webpack_public_path__ + "static/media/lock.a9a78de0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/lock.svg
// module id = 703
// module chunks = 0